import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const PeopleFeedbackBannerWrapper = styled.div`
  position: sticky;
  bottom: 16px;

  width: 100%;
  min-height: 100px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0px 20px;

  border-radius: 8px;
  background: rgba(255, 163, 102, 0.95);

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    padding: 8px 16px;

    bottom: var(--mobile-navbar-height);
  }

  z-index: 10;
`;

export const PeopleFeedbackBannerInformationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PeopleFeedbackBannerButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 14px;

  ${BREAKPOINTS.tablet} {
    width: 100%;

    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;

    & button {
      width: 100%;
    }
  }
`;

export const PeopleFeedbackBannerTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: var(--color-text);
`;

export const PeopleFeedbackBannerInformationIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 14px;

  ${BREAKPOINTS.tablet} {
    gap: 8px;
  }
`;

export const PeopleFeedbackBannerInformationIcon = styled.div`
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100px;
  border: 2px solid var(--color-text);

  cursor: pointer;
`;

export const PeopleFeedbackBannerInformationFeedbackLegend = styled.span`
  padding: 9px 3px;
  border-radius: 8px;
  background: rgba(255, 163, 102, 0.11);

  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;
